import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { LoanLimitViewDistrictsQueryResponse, LoanLimitViewDistrictsQueryParams, LoanLimitViewDistricts400, LoanLimitViewDistricts401, LoanLimitViewDistricts403, LoanLimitViewDistricts404, LoanLimitViewDistricts410, LoanLimitViewDistricts422, LoanLimitViewDistricts429, LoanLimitViewDistricts500 } from "../types/LoanLimitViewDistricts";

export const loanLimitViewDistrictsQueryKey = (params: LoanLimitViewDistrictsQueryParams) =>     [{url:`/api/credit-flow-backend/v1/loan_limit/view_districts`},...(params ? [params] : [])] as const;
      export function loanLimitViewDistrictsQueryOptions <TData = LoanLimitViewDistrictsQueryResponse, TError = LoanLimitViewDistricts400 | LoanLimitViewDistricts401 | LoanLimitViewDistricts403 | LoanLimitViewDistricts404 | LoanLimitViewDistricts410 | LoanLimitViewDistricts422 | LoanLimitViewDistricts429 | LoanLimitViewDistricts500>(params: LoanLimitViewDistrictsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = loanLimitViewDistrictsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/v1/loan_limit/view_districts`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/v1/loan_limit/view_districts
 */

export function useLoanLimitViewDistricts <TData = LoanLimitViewDistrictsQueryResponse, TError = LoanLimitViewDistricts400 | LoanLimitViewDistricts401 | LoanLimitViewDistricts403 | LoanLimitViewDistricts404 | LoanLimitViewDistricts410 | LoanLimitViewDistricts422 | LoanLimitViewDistricts429 | LoanLimitViewDistricts500>(params: LoanLimitViewDistrictsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? loanLimitViewDistrictsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...loanLimitViewDistrictsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
